module.exports = __webpack_public_path__ + "img/sd_icon.0f75b2b8.png";